import React, { useState, useEffect, useMemo } from "react";
import {
  Table,
  message,
  Modal,
  Button,
  Input,
  Select,
  Card,
  Typography,
  Space,
  Divider,
  Tag,
} from "antd";
import { Link } from "react-router-dom";
import axios from "axios";
import { Container, Heading, VStack, useToast } from "@chakra-ui/react";
import "../dell.css";
import RoundscoresPage from "../pages/RoundscoresPage";
import { GridLoader } from "react-spinners";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { firebaseAPI } from "../firebaseConfig";
import * as XLSX from "xlsx"; // Add this import
import { saveAs } from "file-saver"; // Add this import
import StatusDropdown, { statusOptions } from "./StatusDropDown";
import { StatusTag } from "./StatusTag";
import { RoundScoresToolbar } from "./RoundScoresToolbar";
import {
  bulkAssignJudgeToSubmissions,
  bulkChangeParticipantsStatus,
  countMatchingParticipants,
  downloadBatchedEmailsCSV,
  downloadFilteredRoundscoresCSV,
  fetchContactSearchSubmissions,
  fetchFilteredRoundscores,
} from "../api/submissions";
import { gradYearOptions } from "../data/profileOptions";
import { PhoneOutlined, IdcardOutlined } from "@ant-design/icons";
import LoadingView from "./LoadingView";
import axiosInstance from "../utils/axiosInstance";
import { useSearchParams } from "react-router-dom";

const SubmissionsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = parseInt(searchParams.get("page") || "1");
  const limit = parseInt(searchParams.get("limit") || "10");
  const formName = searchParams.get("formName");

  // Fetch using `page`, `limit`, and `formName`
};

const { Option } = Select;
const { confirm } = Modal;
const sanitizeRoundKey = (name) =>
  "round" + name.replace(/\s+/g, "").replace(/[^a-zA-Z0-9]/g, "");

const RoundScoresTable = ({ formName, programName }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const toast = useToast();
  const [programRounds, setProgramRounds] = useState([]);
  const location = useLocation(); // Hook to get current location
  const [program, setProgram] = useState(
    decodeURI(location.pathname.split("/")[1])
  );
  const [gradYearFilter, setGradYearFilter] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [judgeFilter, setJudgeFilter] = useState(null);

  const [genderFilter, setGenderFilter] = useState(null);
  const [disabilityFilter, setDisabilityFilter] = useState(null);
  const [cityFilter, setCityFilter] = useState(null);
  const [universityFilter, setUniversityFilter] = useState(null);
  const [majorFilter, setMajorFilter] = useState(null);

  const [emailFilter, setEmailFilter] = useState(null);
  const [phoneFilter, setPhoneFilter] = useState(null);

  const [batchSize, setBatchSize] = useState(50);
  const [appendEmail, setAppendEmail] = useState("");

  const [judges, setJudges] = useState([]);

  const [dataSource, setDataSource] = useState([]);
  const [threshold, setThreshold] = useState(0);
  const [topN, setTopN] = useState(0);
  const [handledSubmissionsCount, setHandledSubmissionsCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [selectedSubmissionIds, setSelectedSubmissionIds] = useState([]);
  const [selectedSubmissionJudges, setSelectedSubmissionJudges] = useState([]);
  const [scoreFilter, setMinTotalScore] = useState(null);
  const [roundscores, setRoundscores] = useState(new Map());

  const [page, setPage] = useState(parseInt(searchParams.get("page") || "1"));
  const [limit, setLimit] = useState(
    parseInt(searchParams.get("limit") || "10")
  );
  const [totalTableSize, settotalTableSize] = useState(0);

  const [matchingCountLoading, setMatchingCountLoading] = useState(false);
  useEffect(() => {
    // Fetch program rounds when the component mounts or when location changes
    fetchProgramRounds();
    fetchJudges();
  }, [location.pathname]);
  useEffect(() => {
    const params = {
      searchText,
      statusFilter,
      judgeFilter,
      gradYearFilter,
      scoreFilter,
      genderFilter,
      disabilityFilter,
      cityFilter,
      universityFilter,
      majorFilter,
      page,
      limit,
    };

    // Remove empty/null values to keep the URL clean
    const nonEmptyParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== "" && value !== null
      )
    );

    setSearchParams(nonEmptyParams);
  }, [
    searchText,
    statusFilter,
    judgeFilter,
    gradYearFilter,
    scoreFilter,
    genderFilter,
    disabilityFilter,
    cityFilter,
    universityFilter,
    majorFilter,
    page,
    limit,
  ]);

  const calculateSubmissionScore = (submission) => {
    let correctSum = 0;

    const questions = submission.form?.questions || [];
    const answers = submission.answers || [];

    questions.forEach((question, index) => {
      const correctAnswer = question.questionCorrectAnswer;
      const givenAnswer = answers[index]?.questionAnswer;

      // If there's no correct answer defined, count any user answer as correct
      if (!correctAnswer && givenAnswer) {
        correctSum++;
      } else if (correctAnswer && givenAnswer === correctAnswer) {
        correctSum++;
      }
    });

    const formScore = correctSum;
    const judgeScore = submission.judgeScore || 0;
    const totalScore = formScore + judgeScore;

    return {
      ...submission,
      formScore,
      totalScore,
      key: submission.submissionId,
      selected: false,
    };
  };

  const fetchJudges = async () => {
    try {
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(
        `${firebaseAPI}/users/${program}/judges`,
        {
          headers: {
            // A temporary way to manually use token until implement the sign-in feature
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const NoJudge = {
        email: "none",
        role: "judge",
        name: "Not Assigned",
      };
      setJudges([...response.data, NoJudge]);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const fetchProgramRounds = async () => {
    try {
      // Extract program name from URL
      // const programName = location.pathname.split("/")[1]; // Assuming program name is the first part of the path

      // // Fetch program rounds from backend
      // const response = await axiosInstance.get(
      //   `${firebaseAPI}/program/${programName}/rounds`
      // );
      // const { programRounds } = response.data;
      const programRounds = ["CV Screening", "Quiz Round", "Video Interview"];
      // Set program rounds
      setProgramRounds(programRounds);
    } catch (error) {
      console.error("Error fetching program rounds:", error);
    }
  };

  const rowClassName = () => {
    return "white-row"; // Custom class for rows with white background
  };

  const updateSubmissionInfoById = async (submissionId) => {
    try {
      setLoading(true);
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(
        `${firebaseAPI}/submissions/${submissionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //console.log(response.data);
      roundscores.set(submissionId, response.data);
      // calculateSubmissionScore(roundscores.get(submissionId));
      setHandledSubmissionsCount(handledSubmissionsCount + 1);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("No submissions found");
      console.error("Error fetching submission:", error);
    }
  };

  const handleQualify = async (userEmail, submissionId) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Are you sure you want to mark this submission as qualified?",
      onOk: async () => {
        try {
          let token = Cookies.get("token") || "";
          const currentRoundIndex = programRounds.indexOf(formName);
          let nextRound;

          if (currentRoundIndex === programRounds.length - 1) {
            // If it's the last round, remain the same
            nextRound = formName;
          } else {
            // Otherwise, get the next round
            nextRound = programRounds[currentRoundIndex + 1];
          }

          await axiosInstance.post(
            `${firebaseAPI}/qualify`,
            {
              roundName: formName,
              userEmail: userEmail,
              programName: programName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          // updateSubmissionInfoById(submissionId);
        } catch (error) {
          console.error("Error qualifying user:", error);
        }
      },
      onCancel: () => {
        ////console.log('Cancel');
      },
      okText: "Yes",
      cancelText: "No",
    });
  };

  const handleQualifyAllWithScore = async () => {
    Modal.confirm({
      title: "Are you sure?",
      content: `Are you sure you want to qualify All Partcicpants with Score Above ${threshold}`,
      onOk: async () => {
        try {
          setLoading(true);
          let token = Cookies.get("token") || "";
          const currentRoundIndex = programRounds.indexOf(formName);
          let nextRound;

          if (currentRoundIndex === programRounds.length - 1) {
            // If it's the last round, remain the same
            nextRound = formName;
          } else {
            // Otherwise, get the next round
            nextRound = programRounds[currentRoundIndex + 1];
          }

          await axiosInstance.post(
            `${firebaseAPI}/qualify/all/score`,
            {
              roundName: formName,
              threshold: threshold,
              programName: programName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setLoading(false);
          // fetchRoundscores();
        } catch (error) {
          console.error("Error qualifying user:", error);
        }
      },
      onCancel: () => {
        ////console.log('Cancel');
      },
      okText: "Yes",
      cancelText: "No",
    });
  };

  const handleDisqualify = async (userEmail, submissionId) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Are you sure you want to disqualify this submission?",
      onOk: async () => {
        try {
          let token = Cookies.get("token") || "";
          await axiosInstance.post(
            `${firebaseAPI}/disqualify`,
            {
              roundName: formName,
              userEmail: userEmail,
              programName: programName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          // updateSubmissionInfoById(submissionId);
        } catch (error) {
          console.error("Error disqualifying user:", error);
        }
      },
      onCancel: () => {
        ////console.log('Cancel');
      },
      okText: "Yes",
      cancelText: "No",
    });
  };

  const handlePending = async (userEmail, submissionId) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Are you sure you want to mark this submission as pending?",
      onOk: async () => {
        try {
          let token = Cookies.get("token") || "";
          await axiosInstance.post(
            `${firebaseAPI}/pending`,
            {
              roundName: formName,
              userEmail: userEmail,
              programName: programName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          // updateSubmissionInfoById(submissionId);
        } catch (error) {
          console.error("Error marking user as pending:", error);
        }
      },
      onCancel: () => {
        ////console.log('Cancel');
      },
      okText: "Yes",
      cancelText: "No",
    });
  };
  const updateQueryParams = (newParams) => {
    setSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      ...newParams,
    });
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [judgeEmail, setJudgeEmail] = useState("");
  const [currentSubmissionTitle, setCurrentSubmissionTitle] = useState("");
  const [selectedBulkStatus, setSelectedBulkStatus] = useState("pending");
  const [matchingCount, setMatchingCount] = useState(0);
  const filters = {
    searchText,
    statusFilter,
    judgeFilter,
    gradYearFilter,
    scoreFilter,
    genderFilter,
    disabilityFilter,
    cityFilter,
    universityFilter,
    majorFilter,
  };
  let currentJudgeEmail = "";

  const handleAssign = (submissionId, judges) => {
    setModalVisible(true);
    setSelectedSubmissionIds([submissionId]);
    setSelectedSubmissionJudges(judges);
  };

  const [commentsModalVisible, setCommentsModalVisible] = useState(false);
  const handleShowCommentsAndScores = (judges) => {
    setCommentsModalVisible(true);
    setSelectedSubmissionJudges(judges);
  };

  const handleAssignAllSelected = () => {
    // Filter selected submissions
    const selectedSubmissions = dataSource.filter((submission) =>
      selectedSubmissionIds.includes(submission.submissionId)
    );
    // Show modal to assign judges to selected submissions
    setModalVisible(true);
  };

  const handleJudgeSelection = async () => {
    try {
      const token = Cookies.get("token") || "";
      await Promise.all(
        selectedSubmissionIds.map(async (submissionId) => {
          const response = await axiosInstance.post(
            `${firebaseAPI}/submissions/assignJudge`,
            {
              submissionId,
              judgeEmail,
              formName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          // Handle response if needed
        })
      );

      // Close modal and refresh data
      setModalVisible(false);
      // fetchRoundscores(); // Refresh submissions after assigning judges
    } catch (error) {
      console.error("Error assigning judge:", error);
    }
  };

  let exportRoundscores = new Map();
  const fetchAllRoundscores = async () => {
    try {
      setLoading(true);
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(
        `${firebaseAPI}/forms/${formName}/${programName}/submissions/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const newExportRoundscores = new Map();
      //console.log(response.data);
      response.data.submissions.forEach((submission) => {
        newExportRoundscores.set(submission.submissionId, submission);
      });

      //console.log(newExportRoundscores);

      exportRoundscores = newExportRoundscores;
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("No submissions found");
      console.error("Error fetching roundscores:", error);
    }
  };

  const handleAwaitingSubmission = async (userEmail, submissionId) => {};

  const handleStatusChange = (email, submissionId, newStatus) => {
    switch (newStatus) {
      case "pending":
        handlePending(email, submissionId);
        break;
      case "qualified":
        handleQualify(email, submissionId);
        break;
      case "disqualified":
        handleDisqualify(email, submissionId);
        break;
      case "awaiting_submission":
        handleAwaitingSubmission(email, submissionId);
        break;
      default:
        console.warn("Unknown status:", newStatus);
    }
  };

  const handleExport = async () => {
    setExportLoading(true);
    await downloadFilteredRoundscoresCSV({
      programName,
      formName,
      filters,
    });
    setExportLoading(false);
  };

  const handleExportEmails = async () => {
    setExportLoading(true);
    await downloadBatchedEmailsCSV({
      programName,
      formName,
      filters,
      batchSize,
      appendEmail,
    });
    setExportLoading(false);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: ["user", "name"],
      key: "submission_title",
      width: 150,
    },
    {
      title: "Status",
      key: "change_status",
      width: 150,
      render: (_, rec) => (
        <StatusTag
          status={
            rec.participantProfile[`${sanitizeRoundKey(formName)}_status`]
          }
        />
      ),
    },
    {
      title: "CV",
      dataIndex: ["participantProfile", "cvUrl"],
      key: "participant_cv",
      width: 100,
      render: (cv) =>
        cv ? (
          <Button type="link" href={cv} target="_blank" rel="noopener">
            View
          </Button>
        ) : (
          <Tag>—</Tag>
        ),
    },
    {
      title: "University",
      dataIndex: ["participantProfile", "university"],
      key: "university",
      width: 180,
    },
    {
      title: "Major",
      dataIndex: ["participantProfile", "major"],
      key: "major",
      width: 180,
    },
    {
      title: "City",
      dataIndex: ["participantProfile", "city"],
      key: "city",
      width: 120,
    },
    {
      title: "Grad Year",
      dataIndex: ["participantProfile", "gradYear"],
      key: "grad_year",
      width: 100,
    },
    {
      title: "Gender",
      dataIndex: ["participantProfile", "gender"],
      key: "gender",
      width: 100,
    },
    {
      title: "Has Disability?",
      dataIndex: ["participantProfile", "hasDisability"],
      key: "has_disability",
      width: 140,
      render: (d) =>
        d ? (
          <Tag icon={<IdcardOutlined />} color="red">
            Yes
          </Tag>
        ) : (
          <Tag icon={<IdcardOutlined />} color="green">
            No
          </Tag>
        ),
    },
    {
      title: "Disability Spec.",
      dataIndex: ["participantProfile", "disabilitySpecification"],
      key: "disability_spec",
      width: 160,
      render: (txt) => txt || <Tag>—</Tag>,
    },
    {
      title: "Contact",
      dataIndex: ["participantProfile", "mobileNumber"],
      key: "mobile_number",
      width: 160,
      render: (num) =>
        num ? (
          <a href={`tel:${num}`}>
            <PhoneOutlined /> {num}
          </a>
        ) : (
          <Tag>—</Tag>
        ),
    },
    {
      title: "Form Score",
      dataIndex: ["formScore"],
      key: "form_score",
      width: 120,
      sorter: (a, b) => a.formScore - b.formScore,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Judge Avg (%)",
      dataIndex: ["judgeScore"],
      key: "judge_score",
      width: 140,
      sorter: (a, b) => a.judgeScore - b.judgeScore,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Total Score",
      dataIndex: ["totalScore"],
      key: "total_score",
      width: 120,
      sorter: (a, b) => a.totalScore - b.totalScore,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Judges",
      key: "judges",
      width: 180,
      render: (_, { judgesAndScores }) =>
        judgesAndScores.map(({ judge }) => judge.name).join(", "),
    },
    {
      title: "Comments",
      key: "comments",
      width: 120,
      render: (_, rec) => (
        <Button
          disabled={rec.submissionId.substr(0, 11) === "placeholder"}
          onClick={() => handleShowCommentsAndScores(rec.judgesAndScores)}
        >
          View
        </Button>
      ),
    },

    {
      title: "Assign",
      key: "assign",
      width: 120,
      render: (_, rec) => (
        <Button
          disabled={rec.submissionId.substr(0, 11) === "placeholder"}
          onClick={() => handleAssign(rec.submissionId, rec.judgesAndScores)}
        >
          Assign
        </Button>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 140,
      render: (_, rec) => (
        <Link
          to={`/${rec.form.program}/evaluatesubmission/${rec.submissionId}`}
        >
          {/* placeholder here means submissionId is null */}
          <Button
            disabled={rec.submissionId.substr(0, 11) === "placeholder"}
            type="primary"
            block
          >
            {rec.judgeScore ? "Update" : "Evaluate"}
          </Button>
        </Link>
      ),
    },
  ];
  const handleGradYearFilter = (year) => setGradYearFilter(year);
  const handleSearchText = (value) => setSearchText(value);

  const handleGenderFilter = (value) => setGenderFilter(value);
  const handleDisabilityFilter = (value) => setDisabilityFilter(value);
  const handleCityFilter = (value) => setCityFilter(value);
  const handleUniversityFilter = (value) => setUniversityFilter(value);
  const handleMajorFilter = (value) => setMajorFilter(value);

  // handlers for the three filters:
  const handleGlobalSearch = (value) => {
    setSearchText(value);
  };
  const handlePhoneFilter = (value) => {
    setPhoneFilter(value);
  };

  const handleEmailFilter = (value) => {
    setEmailFilter(value);
  };

  const handleStatusFilter = (value) => {
    setStatusFilter(value);
  };
  const handleThresholdFilter = (value) => {
    setMinTotalScore(value);
  };

  const handleJudgeFilter = (value) => {
    setJudgeFilter(value);
  };

  const handleStatusAllSelected = async (status) => {
    try {
      setLoading(true);
      const token = Cookies.get("token") || "";
      const updatedScores = new Map(roundscores); // clone the Map

      await Promise.all(
        selectedSubmissionIds.map(async (submissionId) => {
          const submission = updatedScores.get(submissionId);

          await axiosInstance.post(
            `${firebaseAPI}/status`,
            {
              roundName: formName,
              userEmail: submission.user.email,
              programName,
              status,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          // Optimistically update the status locally
          const roundStatusKey = `${sanitizeRoundKey(formName)}_status`;
          updatedScores.set(submissionId, {
            ...submission,
            participantProfile: {
              ...submission.participantProfile,
              [roundStatusKey]: status,
            },
          });
        })
      );

      setRoundscores(updatedScores); // update local state
      setSelectedSubmissionIds([]); // optionally reset selection
    } catch (error) {
      console.error(
        `Error setting "${status}" on selected submissions:`,
        error
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClearExceptStatus = () => {
    setGradYearFilter(null);
    setSearchText("");
    setJudgeFilter(null);
    setGenderFilter(null);
    setDisabilityFilter(null);
    setCityFilter(null);
    setUniversityFilter(null);
    setMajorFilter(null);
  };
  // 2) apply by status
  const handleApplyStatusToSelected = (status) => {
    if (!status) return;

    const count = selectedSubmissionIds.length;
    console.log(selectedSubmissionIds);
    const label =
      statusOptions.find((opt) => opt.value === status)?.label || status;

    confirm({
      title: "Change status confirmation",
      content: `Are you sure you want to change status of ${count} participants${
        count > 1 ? "s" : ""
      } to "${label}"?`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        handleStatusAllSelected(status);
      },
    });
  };
  const handleApplyStatusToFiltered = (status) => {
    if (!status) return;

    const label =
      statusOptions.find((opt) => opt.value === status)?.label || status;

    confirm({
      title: "Change status confirmation",
      content: `Are you sure you want to change status of ${matchingCount} participant${
        matchingCount > 1 ? "s" : ""
      } to "${label}"?`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        sendBulkStatusUpdate(status);
      },
    });
  };
  const handleApplyJudgeToFiltered = (selectedJudgeEmail) => {
    if (!selectedJudgeEmail) return;

    confirm({
      title: "Assign Judge Confirmation",
      content: `Are you sure you want to assign judge "${selectedJudgeEmail}" to ${matchingCount} submission${
        matchingCount > 1 ? "s" : ""
      }?`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        sendBulkJudgeUpdate(selectedJudgeEmail);
      },
    });
  };

  const fetchScores = async ({
    programName: propProgramName,
    formName,
    filters = {},
    page = 1,
    limit = 20,
  }) => {
    setLoading(true);
    // track mounted state to prevent setState after unmount
    let isMounted = true;
    // if you’re inside a useEffect, return a cleanup that flips this flag
    // useEffect(() => () => { isMounted = false }, []);

    try {
      const programName = propProgramName || location.pathname.split("/")[1];
      if (!programName) {
        throw new Error("Program name is required");
      }

      const { submissions = [], totalPages = 0 } =
        await fetchFilteredRoundscores({
          programName,
          formName,
          filters,
          page,
          limit,
        });
      // Safely clear and rebuild the Map
      try {
        roundscores.clear();
        submissions.forEach((submission) => {
          const key = submission.submissionId;
          if (key != null) {
            roundscores.set(key, {
              // fill in defaults so downstream never sees undefined
              judgeScore: submission.judgeScore ?? 0,
              judgesAndScores: submission.judgesAndScores ?? [],
              submissionId: key,
              ...submission,
            });
          }
        });
      } catch (mapError) {
        console.error("Error updating roundscores Map:", mapError);
        // decide whether to bail out or continue. here we continue.
      }

      // const updatedDataSource = [...roundscores.values()].map(
      //   calculateSubmissionScore
      // );
      const updatedDataSource = [...roundscores.values()];

      if (isMounted) {
        setRoundscores(new Map(roundscores)); // trigger React update
        setDataSource(updatedDataSource);
        settotalTableSize(totalPages * limit);
      }

      return submissions;
    } catch (err) {
      const serverMessage = err?.message || "Failed to load submissions";
      message.error(serverMessage);
      console.error("fetchScores error:", err);

      // still update pages so UI paginator doesn't get stuck
      if (isMounted) {
        settotalTableSize(0);
      }

      // re-throw so callers can handle if needed
      throw err;
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  };

  const fetchContactScores = async ({
    programName: propProgramName,
    formName,
    email,
    phone,
  }) => {
    setLoading(true);
    let isMounted = true;

    try {
      const programName = propProgramName || location.pathname.split("/")[1];
      if (!programName) {
        throw new Error("Program name is required");
      }

      if (!email && !phone) {
        throw new Error("Email or phone must be provided for contact search.");
      }

      const { submissions = [], totalPages = 0 } =
        await fetchContactSearchSubmissions({
          programName,
          formName,
          email,
          phone,
        });

      try {
        roundscores.clear();
        submissions.forEach((submission) => {
          const key = submission.submissionId;
          if (key != null) {
            roundscores.set(key, {
              judgeScore: submission.judgeScore ?? 0,
              judgesAndScores: submission.judgesAndScores ?? [],
              submissionId: key,
              ...submission,
            });
          }
        });
      } catch (mapError) {
        console.error("Error updating roundscores Map:", mapError);
      }

      const updatedDataSource = [...roundscores.values()].map(
        calculateSubmissionScore
      );

      if (isMounted) {
        setRoundscores(new Map(roundscores));
        setDataSource(updatedDataSource);
        settotalTableSize(totalPages); // Should be 1 always in this search
      }

      return submissions;
    } catch (err) {
      const serverMessage =
        err?.message || "Failed to load submissions by contact";
      message.error(serverMessage);
      console.error("fetchContactScores error:", err);

      if (isMounted) {
        settotalTableSize(0);
      }

      throw err;
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  };

  const loadScores = async () => {
    try {
      const data = await fetchScores({
        programName: location.pathname.split("/")[1],
        formName: formName,
        filters,
        page: page,
        limit: limit,
      });
    } catch (err) {
      // Error already handled by message.error in fetchScores
    }
  };
  const loadContactScores = async () => {
    try {
      const data = await fetchContactScores({
        programName: location.pathname.split("/")[1],
        formName: formName,
        email: emailFilter,
        phone: phoneFilter,
      });
    } catch (err) {
      // Error already handled by message.error in fetchContactScores
    }
  };

  const sendBulkStatusUpdate = async (status) => {
    try {
      setLoading(true);
      await bulkChangeParticipantsStatus({
        programName,
        formName,
        filters,
        newStatus: status,
      });
      setLoading(false);
      message.success("Bulk status update successful");
    } catch (err) {
      console.error("Failed to bulk status:", err);
    }
  };
  const sendBulkJudgeUpdate = async (judgeEmail) => {
    try {
      setLoading(true);
      await bulkAssignJudgeToSubmissions({
        programName,
        formName,
        filters,
        judgeEmail,
      });
      setLoading(false);
      message.success("Bulk judge update successful");
    } catch (err) {
      console.error("Failed to bulk judge:", err);
    }
  };
  const handleClear = () => {
    setGradYearFilter(null);
    setSearchText("");
    setStatusFilter(null);
    setJudgeFilter(null);
    setGenderFilter(null);
    setDisabilityFilter(null);
    setCityFilter(null);
    setUniversityFilter(null);
    setMajorFilter(null);
    setMinTotalScore(null);
  };
  useEffect(() => {}, [roundscores, handledSubmissionsCount]);
  useEffect(() => {
    const fetchCount = async () => {
      try {
        setMatchingCountLoading(true);
        const count = await countMatchingParticipants({
          programName,
          formName,
          filters,
        });
        setMatchingCount(count);
        setMatchingCountLoading(false);
      } catch (err) {
        console.error("Failed to fetch count:", err);
      }
    };

    fetchCount();
  }, [
    filters.searchText,
    filters.statusFilter,
    filters.judgeFilter,
    filters.gradYearFilter,
    filters.scoreFilter,
    filters.genderFilter,
    filters.disabilityFilter,
    filters.cityFilter,
    filters.universityFilter,
    filters.majorFilter,
    programName,
    formName,
  ]);
  // Load Submissions once
  useEffect(() => {
    loadScores();
  }, []);

  return (
    <div className="participant-table-container">
      {loading && <LoadingView />}

      <Space direction="vertical" style={{ width: "100%" }} size="large">
        {/* Filters Toolbar */}
        <RoundScoresToolbar
          formName={formName}
          gradYears={gradYearOptions}
          judges={judges}
          threshold={threshold}
          setThreshold={setThreshold}
          handleGradYearFilter={handleGradYearFilter}
          handleStatusFilter={handleStatusFilter}
          handleThresholdFilter={handleThresholdFilter}
          handleJudgeFilter={handleJudgeFilter}
          selectedBulkStatus={selectedBulkStatus}
          setSelectedBulkStatus={setSelectedBulkStatus}
          handleGenderFilter={handleGenderFilter}
          handleDisabilityFilter={handleDisabilityFilter}
          handleCityFilter={handleCityFilter}
          handleUniversityFilter={handleUniversityFilter}
          handleMajorFilter={handleMajorFilter}
          handleApplyStatusToSelected={handleApplyStatusToSelected}
          handleApplyStatusToFiltered={handleApplyStatusToFiltered}
          handleApplyJudgeToFiltered={handleApplyJudgeToFiltered}
          handleExport={handleExport}
          handleExportEmails={handleExportEmails}
          matchingCount={matchingCount}
          filters={filters}
          loadScores={loadScores}
          handleAssignAllSelected={handleAssignAllSelected}
          exportLoading={exportLoading}
          handleClear={handleClear}
          handleClearExceptStatus={handleClearExceptStatus}
          handleEmailFilter={handleEmailFilter}
          handlePhoneFilter={handlePhoneFilter}
          emailFilter={emailFilter}
          phoneFilter={phoneFilter}
          loadContactScores={loadContactScores}
          batchSize={batchSize}
          setBatchSize={setBatchSize}
          appendEmail={appendEmail}
          setAppendEmail={setAppendEmail}
          matchingCountLoading={matchingCountLoading}
        />

        {/* Divider for visual separation */}
        <Divider orientation="left">Submissions</Divider>

        {/* Participant Table */}
        <Table
          key={roundscores}
          dataSource={dataSource}
          columns={columns}
          loading={loading}
          rowSelection={{
            selectedRowKeys: selectedSubmissionIds,
            onChange: (keys, rows) => {
              setSelectedSubmissionIds(keys);
              const judgesSet = new Set(
                rows.flatMap((r) => r.judgesAndScores ?? [])
              );
              setSelectedSubmissionJudges([...judgesSet]);
            },
          }}
          pagination={{
            current: page,
            pageSize: limit,
            total: totalTableSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            onChange: (newPage, newPageSize) => {
              updateQueryParams({ page: newPage, limit: newPageSize });
              setPage(newPage);
              setLimit(newPageSize);
              fetchScores({
                formName,
                filters,
                page: newPage,
                limit: newPageSize,
              }).catch(() => {
                // optionally reset page or show a fallback
              });
            },
          }}
          scroll={{ x: "max-content", y: 500 }}
          sticky
          rowKey="submissionId"
        />

        {/* Assign Judges Modal */}
        <Modal
          title="Assign Judges"
          visible={modalVisible}
          onOk={handleJudgeSelection}
          onCancel={() => setModalVisible(false)}
        >
          <Select
            allowClear
            showSearch
            placeholder="Select judge's email"
            onChange={setJudgeEmail}
            style={{ width: "100%" }}
          >
            {judges
              // .filter(
              //   (j) =>
              //     !selectedSubmissionJudges
              //       .map((s) => s.judge.email)
              //       .includes(j.email)
              // )
              .map((judge) => (
                <Option key={judge.email} value={judge.email}>
                  {judge.email}
                </Option>
              ))}
          </Select>
        </Modal>

        {/* Comments & Scores Modal */}
        <Modal
          title="Submission Comments and Scores"
          visible={commentsModalVisible}
          onOk={() => setCommentsModalVisible(false)}
          okText="Done"
          onCancel={() => setCommentsModalVisible(false)}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {selectedSubmissionJudges.map(
              ({ judge, judgeScore, judgeComment }) => (
                <Card style={{ marginBottom: 8 }} key={judge.email}>
                  <Typography.Text strong>
                    {judge.name} – ({judgeScore}%)
                  </Typography.Text>
                  <Typography.Paragraph>"{judgeComment}"</Typography.Paragraph>
                </Card>
              )
            )}
            <Divider />
            <Typography.Text strong>
              Average Score:{" "}
              {(
                selectedSubmissionJudges.reduce(
                  (sum, { judgeScore }) => sum + judgeScore,
                  0
                ) / selectedSubmissionJudges.length
              ).toFixed(1)}
              %
            </Typography.Text>
          </Space>
        </Modal>
      </Space>
    </div>
  );
};

export default RoundScoresTable;
